export function parseBool(str: string): boolean | undefined {
  if (/^true$/i.test(str)) return true
  if (/^false$/i.test(str)) return false
}

export function isBoolean(value: unknown): value is boolean {
  return typeof value === 'boolean'
}
